import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";
import { guarded } from "../hr/Guard";

/** Duyurular ve "Politikalar" bilgi bankası. Bilgi mimarisi: docs/UX.md §2. */
export const routes: FeatureRoute[] = [
  { path: "duyurular", Component: lazy(() => import("./AnnouncementsPage")) },
  { path: "duyurular/:id", Component: lazy(() => import("./AnnouncementPage")) },
  // Duyuru yönetimi menüdeki yetkiyle korunur: adresle gelen yetkisiz kişi açık mesaj görür.
  { path: "ik/duyurular", Component: guarded(["announcements.manage"], "Duyuru yönetimi", () => import("./ManageAnnouncementsPage")) },
  { path: "ik/duyurular/yeni", Component: guarded(["announcements.manage"], "Duyuru oluştur", () => import("./AnnouncementEditPage")) },
  { path: "ik/duyurular/:id", Component: guarded(["announcements.manage"], "Duyuru", () => import("./AnnouncementAdminPage")) },
  { path: "ik/duyurular/:id/duzenle", Component: guarded(["announcements.manage"], "Duyuruyu düzenle", () => import("./AnnouncementEditPage")) },
  { path: "bilgi", Component: lazy(() => import("./KnowledgePage")) },
  { path: "bilgi/yeni", Component: lazy(() => import("./ArticleEditPage")) },
  { path: "bilgi/:id", Component: lazy(() => import("./ArticlePage")) },
  { path: "bilgi/:id/duzenle", Component: lazy(() => import("./ArticleEditPage")) },
  { path: "ik/bilgi", Component: lazy(() => import("./Redirects").then((m) => ({ default: m.ToKnowledge }))) },
  { path: "bilgi-bankasi/:id", Component: lazy(() => import("./Redirects").then((m) => ({ default: m.ToArticle }))) },
];
